module.exports = __webpack_public_path__ + "media/components/app-store/static/s9-26f4776ba6eed68088ef79aca303f37f.jpg";